import { render, staticRenderFns } from "./finance-company-details.vue?vue&type=template&id=6b991589&scoped=true&"
import script from "./finance-company-details.vue?vue&type=script&lang=js&"
export * from "./finance-company-details.vue?vue&type=script&lang=js&"
import style0 from "./finance-company-details.vue?vue&type=style&index=0&id=6b991589&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b991589",
  null
  
)

export default component.exports